import { useEffect, useState } from "react";

export default function SplashScreen({ onDone }) {
    const [fadingOut, setFadingOut] = useState(false);

    useEffect(() => {
        // Start fade after 2.4s, remove at 3s
        const fadeTimer = setTimeout(() => setFadingOut(true), 2400);
        const doneTimer = setTimeout(() => onDone?.(), 3000);
        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(doneTimer);
        };
    }, [onDone]);

    return (
        <div
            className={`fixed inset-0 z-[9999] flex items-center justify-center bg-[#050505] transition-opacity duration-500 ${fadingOut ? "opacity-0 pointer-events-none" : "opacity-100"}`}
            data-testid="splash-screen"
        >
            {/* Radial glow */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-[#FF5722]/20 blur-[120px]" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#25D366]/10 blur-[140px]" />
            </div>

            <div className="relative flex flex-col items-center gap-4 splash-pop">
                <img
                    src="/logo.png"
                    alt="VIDMAR"
                    className="w-64 h-64 sm:w-72 sm:h-72 object-contain drop-shadow-[0_0_40px_rgba(255,87,34,0.5)]"
                    data-testid="splash-logo"
                />
                <div className="flex items-center gap-1.5 mt-2">
                    <span className="w-2 h-2 rounded-full bg-[#FF5722] splash-dot" style={{ animationDelay: "0ms" }} />
                    <span className="w-2 h-2 rounded-full bg-[#FFC107] splash-dot" style={{ animationDelay: "150ms" }} />
                    <span className="w-2 h-2 rounded-full bg-[#25D366] splash-dot" style={{ animationDelay: "300ms" }} />
                </div>
            </div>
        </div>
    );
}
